import React, { Component } from 'react';
import _ from 'lodash';
import { Cookies } from 'react-cookie';
import {Element} from 'react-scroll';
import {Helmet} from 'react-helmet';

import ScrollButton from '../../components/Header/ScrollButton.jsx';
import LearnMore from '../../components/Forms/LearnMoreInline';
import ReasonsMedicaid from '../../components/Reasons/ReasonsMedicaid';
import {encodeUrl} from '../../helpers/quiz';
import * as RouteHelpers from '../../helpers/routes';
import * as ResultHelpers from '../../helpers/results';

class ResultsCHP extends Component {
  state = {
    plan: {},
    loading: true,
    url: `${process.env.REACT_APP_API_URL}/plans/individual`,
    formResults: _.clone(this.props.fieldValues),
    trackOnce: true
  };

  componentDidMount () {
    const p = _.clone(this.props);
    const cookies = new Cookies();

    if (cookies.get('CDPHP_myResults') && this.props.showResults) { // Check for cookie
      this.setState({ formResults: cookies.get('CDPHP_myResults') });
    }

    if (p.route !== 'quote') {
      const fieldValues = _.merge({}, p.quiz.fieldValues, {'ResultsType': 'ResultsCHP'});
      const resultString = encodeUrl(fieldValues);
      cookies.set('CDPHP_quoteString', resultString, { path: '/' });
      RouteHelpers.history.push('/quote/' + resultString);
    } else if (Object.keys(p.rest.quote).length === 0) {
      p.reducer({fieldValues: p.quiz.fieldValues, url: 'individual'});
      p.updateHeaderPhone('866-692-3747');
      p.toggleInQuiz(false);
      p.toggleInResults(true);
      p.updateResultsFooter(true, {
        // 'jdpower': 'true',
        'results': 'true'
      });
      p.updateResultsRatings(true, {
        // 'jdpower': 'true'
      });
      p.updateHeaderScroller(
        <ScrollButton
          text='Contact Me'
          scrollName='learnForm'
          scrollOpts={{
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart',
            offset: -200
          }}
        />
      );
    }
  }

  static getDerivedStateFromProps (props, state) {
    const p = _.clone(props);
    const {rest} = p;

    if (_.isObject(rest.quote) && Object.keys(rest.quote).length && state.trackOnce === true) {
      // set state once we have data from the server on the selected plan:

      ResultHelpers.sendAnalyticsOnQuote(p.quiz.fieldValues, rest);

      let numberOfKids = _.clone(props.quiz.fieldValues.KidsCount);
      let childLang = null;
      let chpTotal = (numberOfKids * props.rest.quote.ChpCostPerChild);
      let chpMax = props.rest.quote.ChpSubsidizedMax;
      let monthlyCHP = null;
      let subsidized = null;

      if (props.rest.quote.ChpIsSubsidized) {
        subsidized = 'subsidized';
        if (chpTotal < chpMax) monthlyCHP = chpTotal;
        else monthlyCHP = chpMax;
      } else monthlyCHP = chpTotal;

      if (numberOfKids === 1) childLang = 'child is';
      else childLang = 'children are';

      return {
        numberOfKids,
        childLang,
        chpTotal,
        chpMax,
        monthlyCHP,
        subsidized,
        loading: false,
        formResults: p.quiz.fieldValues,
        fieldValues: p.quiz.fieldValues,
        trackOnce: false
      };
    }

    return null;
  }

  setCookie = (data) => {
    const cookies = new Cookies();
    cookies.set('CDPHP_myResults', data, { path: '/' });
  };

  render () {
    const s = _.clone(this.state);
    const {
      numberOfKids,
      childLang,
      monthlyCHP,
      subsidized
    } = s;

    let loading;
    if (this.state.loading) {
      loading = 'loading';
    }

    // Send Location Through
    const cookies = new Cookies();
    let Loc = _.clone(this.props.location);
    if (cookies.get('CDPHP_myResults')) {
      Loc = cookies.get('CDPHP_myResults').Location;
    }

    return (
      <div className={'single ' + loading}>
        <Helmet>
          <title>Your CDPHP Child Health Plus Plan Quote</title>
        </Helmet>
        <section id='intro'>
          <div className='wrap'>
            <h1>We have just the solution for your children.</h1>
            <h3>Based on your answers, your {numberOfKids} {childLang} eligible for {subsidized}<br />
              <strong>Child Health Plus</strong> for a total of <strong>${monthlyCHP}</strong> / month.*</h3>
          </div>
        </section>

        <ReasonsMedicaid chp='true' />

        <Element name='learnForm'>
          <section className='divide pt60 mt60'>
            <div className='wrap'>
              <h4>
                To confirm that you qualify, and get help making the best choice,<br /> feel free to contact us. <strong>Call <a href='tel:866-692-3747' className='tel phoneswap'>866-692-3747</a></strong> or complete the short form.
              </h4>
            </div>
          </section>

          <LearnMore
            area='CHPOnlyResult'
            details={this.state.formResults}
            Location={Loc}
          />
        </Element>
      </div>
    );
  }
}

export default ResultsCHP;
